import React, {useCallback, useState, createContext, useContext } from "react";
import "../style/toast.css";

const ToastContext = createContext();

export default ToastContext;

export function ToastContextProvider({ children }) {
    const [toasts, setToasts] = useState([]);


    const addToast = useCallback(
        function(toast) {
            setToasts((toasts)=> [...toasts, toast]);
            setTimeout(() => setToasts((toasts) => toasts.slice(1)), 3000);
        }, [setToasts]
    );

    return (
        <ToastContext.Provider value={addToast}>
            {children}
            <div className="toasts-wrapper">
                {toasts.map(toast => (
                    <div className="toast" key={toast}><p>{toast}</p></div>
                ))}
            </div>
        </ToastContext.Provider>
    )
}

export function useToastContext() {
    return useContext(ToastContext)
}